export default "__VITE_ASSET__fc8003d7__"